import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    // logErrorToMyService(error, info.componentStack);
    console.error({ error, info });
    this.setState({
      error,
      info,
      hasError: true,
    });
  }

  render() {
    const errorMessage = "An error has occurred";

    const contactInfo = (
      <div>
        Please try again or
        <a
          href="mailto:support@botcircuits.com?subject=Request For Botcircuits Support"
          className="text-blue-600"
        >
          {" "}
          contact support
        </a>{" "}
        with the error code below if the issue persists.
      </div>
    );

    if (this.state.hasError) {
      console.log(this.state.error);
      return (
        <div
          className="flex h-[75vh] items-center justify-center"
          data-test="ErrorBoundary-error-info"
        >
          {/* Generic Component  */}
          <div className="text-center">
            <p>{errorMessage}</p>
            <p className="text-sm text-gray-500">{contactInfo}</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
